const INVALID_COUNTERPART_IDS = new Set(['null', 'undefined'])

export const normalizeCounterpartId = (
  value: string | null | undefined
): string | null => {
  if (value == null) return null

  const trimmed = value.trim()
  if (!trimmed) return null

  if (INVALID_COUNTERPART_IDS.has(trimmed.toLowerCase())) return null

  return trimmed
}

export const isValidCounterpartId = (
  value: string | null | undefined
): value is string => normalizeCounterpartId(value) != null

export const buildCounterpartQuery = (
  counterpartId: string | null | undefined
) => {
  const normalized = normalizeCounterpartId(counterpartId)
  return normalized ? `?rmid=${encodeURIComponent(normalized)}` : ''
}
